export const CommodityForm = {
  model: 'Commodity',
  format: [
    {
      widths: 'equal',
      fields: {
        name: {
          required: true,
          type: 'text',
          url: '/main/commodities/',
          label: 'Commodity Name',
          title_fields: ['name'],
        },
        commodity_group: {
          required: true,
          type: 'dropdown search',
          url: '/main/commodity-groups/',
          label: 'Select or Create Commodity Group',
          title_fields: ['name'],
          filter_field: 'name__icontains',
          allow_add: true,
          allow_add_related_params: {
            commodity_group: 'commodity_group_id',
          },
          description_fields: [],
          model: 'CommodityGroup',
          model_form: 'CommodityGroupForm',
        },
      },
    },
  ],
}
